var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1",class:`animation-${_vm.speed}-speed ${_vm.color}-background-color`}),_c('div',{staticClass:"double-bounce2",class:`animation-${_vm.speed}-speed ${_vm.color}-background-color ${_vm.speed}-speed`})])
}
var staticRenderFns = []

export { render, staticRenderFns }